/**
 * Open/closed state for the assistant popup panel. A global `useState` (not a
 * route query param) so the panel stays open while the user navigates around
 * the app — the whole point of the docked-popup design. The panel always docks
 * bottom-right (bottom sheet on phones).
 */
export function useAssistantPanel() {
  const isOpen = useState('assistantPanelOpen', () => false);

  const open = () => {
    isOpen.value = true;
  };
  const close = () => {
    isOpen.value = false;
  };
  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {isOpen, open, close, toggle};
}
